import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Trace = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.558 8.666H0V7.334h1.35a6.818 6.818 0 0 1 1.923-4.105A6.688 6.688 0 0 1 7.361 1.27L7.396 0H8.73l-.036 2.486c-2.075 0-3.613.492-4.91 2.183l3.569-.027a.66.66 0 0 1 .661.662c0 .366-.295.67-.661.67l-4.32.027c-.42 1.064-.474 1.565-.474 2.665Zm12.163 0a6.788 6.788 0 0 1-1.896 4.088 6.637 6.637 0 0 1-4.132 1.976V16H7.37l-.017-2.486c2.11 0 3.63-.465 4.945-2.182h-3.63a.668.668 0 0 1-.671-.662.67.67 0 0 1 .67-.671h4.383c.411-1.038.456-1.592.456-2.656l2.486.026L16 8.702l-1.279-.036Zm-9.39-1.332h5.312v1.332H5.33V7.334Z"
      fill="currentColor"
    />
  </Icon>
));

export default Trace;
